<div class="position-relative overflow-hidden h-100 d-flex">
    <div class="flex-grow-1 overflow-hidden px-sm-4 pt-4">
        <dx-data-grid
            id="gridContainer"
            class="grid theme-dependent"
            noDataText=""
            [dataSource]="dataSource"
            [allowColumnResizing]="true"
            [focusedRowEnabled]="true"
            [autoNavigateToFocusedRow]="false"
            [showBorders]="true"
            [remoteOperations]="true"
            [columnAutoWidth]="true"
            [wordWrapEnabled]="false"
            [stateStoring]="{ enabled: true, type: 'localStorage', storageKey: 'employee-grid-state', savingTimeout: 0 }"
            [(focusedRowKey)]="employeeId"
            (onRowDblClick)="onRowDblClick($event)"
            (onExporting)="onExporting($event)"
            [customizeColumns]="customizeColumns"
            keyExpr="id"
            width="100%"
        >
            <dxo-scrolling [scrollByContent]="true"></dxo-scrolling>
            <dxo-paging [pageSize]="10"></dxo-paging>
            <dxo-pager
                [visible]="true"
                [displayMode]="'full'"
                [showPageSizeSelector]="true"
                [showInfo]="true"
                [showNavigationButtons]="true"
            >
            </dxo-pager>

            <dxo-load-panel [showPane]="false"></dxo-load-panel>
            <dxo-sorting mode="multiple"></dxo-sorting>
            <dxo-header-filter [visible]="true"></dxo-header-filter>
            <dxo-filter-row [visible]="true" [applyFilter]="'auto'"></dxo-filter-row>
            <dxo-column-chooser [enabled]="true"></dxo-column-chooser>
            <dxo-search-panel
                [visible]="true"
                placeholder="Search"
            ></dxo-search-panel>
            <dxo-export [enabled]="true" [formats]="['xlsx']"></dxo-export>
            <dxo-column-chooser height="340px" [enabled]="true" [mode]="'select'">
                <dxo-position my="right top" at="right bottom" of=".dx-datagrid-column-chooser-button"></dxo-position>
                <dxo-search [enabled]="true"></dxo-search>
                <dxo-selection [allowSelectAll]="true" [selectByClick]="true" [recursive]="true"></dxo-selection>
            </dxo-column-chooser>

            <dxo-toolbar>
                <dxi-item location="before">
                    <div class="grid-header">Employees</div>
                </dxi-item>
                <dxi-item
                    location="after"
                    locateInMenu="auto"
                    widget="dxButton"
                    [options]="{ text: 'Filters', icon: 'fa-sharp fa-thin fa-filter', onClick: toggleFilters, stylingMode: 'text' }"
                ></dxi-item>
                <dxi-item location="after" locateInMenu="auto">
                    <div class="separator"></div>
                </dxi-item>
                <dxi-item
                    location="after"
                    locateInMenu="auto"
                    showText="inMenu"
                    widget="dxButton"
                    [options]="{ text: 'Clear Filters', icon: 'fa-sharp fa-thin fa-filter-slash', onClick: clearFilters, stylingMode: 'text' }"
                ></dxi-item>
                <dxi-item
                    location="after"
                    locateInMenu="auto"
                    showText="inMenu"
                    widget="dxButton"
                    [options]="{
                    text: 'Reset',
                    icon: 'restore',
                    onClick: resetGrid,
                    stylingMode: 'text'
                }"
                ></dxi-item>
                <!-- Separator -->
                <dxi-item location="after" locateInMenu="auto">
                    <div class="separator"></div>
                </dxi-item>
                <dxi-item name="columnChooserButton" locateInMenu="auto"></dxi-item>
                <dxi-item name="exportButton"></dxi-item>
                <dxi-item
                    location="after"
                    locateInMenu="never"
                    [visible]="authService.checkPermission(PermissionType.CreateNewEmployee, AccessType.Manage)"
                >
                    <dx-button
                        text="New Employee"
                        icon="plus"
                        type="default"
                        stylingMode="contained"
                        (onClick)="addEmployee()"
                    ></dx-button>
                </dxi-item>
            </dxo-toolbar>

            <dxi-column
                [dataField]="gridFieldName('name')"
                caption="Name"
                [sortIndex]="1"
                sortOrder="asc"
                [hidingPriority]="23"
                cellTemplate="name"
                [minWidth]="200"
                [calculateFilterExpression]="nameOrEmailFilter"
            ></dxi-column>
            @if (authService.checkPermission(PermissionType.EmployeeEmploymentDetailsOthers, AccessType.ViewOnly)) {
                <dxi-column
                    [allowSearch]="false"
                    [dataField]="gridFieldName('positionStatus')"
                    [lookup]="{ dataSource: statusOptions, valueExpr: 'value', displayExpr: 'text' }"
                    caption="Status"
                    cellTemplate="cellStatus"
                    [hidingPriority]="22"
                    [filterOperations]="['=']"
                    [headerFilter]="{ dataSource: statusOptions }"
                    [minWidth]="150"
                ></dxi-column>
            }
            @if (authService.checkPermission(PermissionType.EmployeeShiftDetailsOthers, AccessType.ViewOnly)) {
                <dxi-column
                    [allowSearch]="false"
                    [allowFiltering]="true"
                    [allowSorting]="false"
                    [dataField]="gridFieldName('shiftType')"
                    caption="Shift"
                    [hidingPriority]="5"
                    [lookup]="{ dataSource: shiftTypeOptions, valueExpr: 'value', displayExpr: 'text' }"
                    [filterOperations]="['=']"
                    [headerFilter]="{ dataSource: shiftTypeOptions }"
                    [minWidth]="150"
                ></dxi-column>
            }
            <dxi-column
                [allowSearch]="false"
                [dataField]="gridFieldName('punchInStatus')"
                caption="Clock In Status"
                [hidingPriority]="21"
                [minWidth]="150"
                cellTemplate="cellClockInStatus"
                [lookup]="{ dataSource: clockInStatusOptions, valueExpr: 'value', displayExpr: 'text' }"
            ></dxi-column>
            <dxi-column
                [allowSearch]="false"
                [dataField]="gridFieldName('punchOutStatus')"
                caption="Clock Out Status"
                [hidingPriority]="20"
                [minWidth]="170"
                cellTemplate="cellClockOutStatus"
                [lookup]="{ dataSource: clockOutStatusOptions, valueExpr: 'value', displayExpr: 'text' }"
            ></dxi-column>
            <dxi-column
                [allowSearch]="false"
                [allowFiltering]="false"
                [allowSorting]="false"
                [dataField]="gridFieldName('requests')"
                caption="Requests"
                [hidingPriority]="19"
                [minWidth]="100"
                [alignment]="'left'"
                dataType="number"
                cellTemplate="cellRequests"
            ></dxi-column>
            <dxi-column
                [allowSearch]="false"
                [dataField]="gridFieldName('lastUpdated')"
                caption="Last Updated"
                [hidingPriority]="18"
                [minWidth]="150"
                cellTemplate="cellDate"
                [dataType]="'date'"
                selectedFilterOperation=">="
                [sortIndex]="0"
                [sortOrder]="'desc'"
            ></dxi-column>

            @if (authService.checkPermission(PermissionType.EmployeeEmploymentDetailsOthers, AccessType.ViewOnly)) {
                <dxi-column
                            [allowSearch]="false" [visible]="false" [dataField]="gridFieldName('positionId')" caption="Position id"
                            [hidingPriority]="17"
                            cellTemplate="cellDefault"
                            [minWidth]="150"></dxi-column>
            }
            @if (authService.checkPermission(PermissionType.EmployeeEmploymentDetailsOthers, AccessType.ViewOnly)) {
                <dxi-column
                            [allowSearch]="false" [visible]="false" [dataField]="gridFieldName('homeCostNumberCode')"
                            caption="Home cost number code"
                            cellTemplate="cellDefault"
                            [hidingPriority]="16" [minWidth]="150"></dxi-column>
            }
            @if (authService.checkPermission(PermissionType.EmployeeEmploymentDetailsOthers, AccessType.ViewOnly)) {
                <dxi-column
                            [allowSearch]="false" [visible]="false" [dataField]="gridFieldName('homeDepartmentCode')"
                            caption="Home Department Code"
                            cellTemplate="cellDefault"
                            [hidingPriority]="1" [minWidth]="150"></dxi-column>
            }
            @if (authService.checkPermission(PermissionType.EmployeeEmploymentDetailsOthers, AccessType.ViewOnly)) {
                <dxi-column
                            [allowSearch]="false" [visible]="false" [dataField]="gridFieldName('payClass')" caption="Pay class"
                            [hidingPriority]="15"
                            cellTemplate="cellCapitalUpper"
                            [minWidth]="150"
                >
                </dxi-column>
            }
            @if (authService.checkPermission(PermissionType.UserEmergencyDetailsOthers, AccessType.ViewOnly)) {
                <dxi-column
                            [allowSearch]="false" [visible]="false" [dataField]="gridFieldName('emergencyContactName')"
                            caption="Emergency contact name"
                            cellTemplate="cellDefault"
                            [hidingPriority]="14" [minWidth]="150"></dxi-column>
            }
            @if (authService.checkPermission(PermissionType.UserEmergencyDetailsOthers, AccessType.ViewOnly)) {
                <dxi-column
                            [allowSearch]="false" [visible]="false" [dataField]="gridFieldName('emergencyContactNumber')"
                            caption="Emergency contact number"
                            cellTemplate="cellDefault"
                            [hidingPriority]="13" [minWidth]="150"></dxi-column>
            }
            @if (authService.checkPermission(PermissionType.UserEmergencyDetailsOthers, AccessType.ViewOnly)) {
                <dxi-column
                            [allowSearch]="false" [visible]="false" [dataField]="gridFieldName('medicalConditions')"
                            caption="Medical conditions"
                            cellTemplate="cellDefault"
                            [hidingPriority]="12" [minWidth]="150"></dxi-column>
            }
            @if (authService.checkPermission(PermissionType.EmployeeEmploymentDetailsOthers, AccessType.ViewOnly)) {
                <dxi-column
                            [allowSearch]="false" [visible]="false" [dataField]="gridFieldName('taxId')" caption="Tax id"
                            [hidingPriority]="11"
                            cellTemplate="cellDefault"
                            [minWidth]="150"></dxi-column>
            }
            @if (authService.checkPermission(PermissionType.EmployeeEmploymentDetailsOthers, AccessType.ViewOnly)) {
                <dxi-column
                            [allowSearch]="false" [visible]="false" [dataField]="gridFieldName('payrollCompanyCode')"
                            caption="Payroll company code"
                            cellTemplate="cellUpper"
                            [hidingPriority]="10" [minWidth]="150"
                            [lookup]="{ dataSource: payrollCompanyCodeOptions, valueExpr: 'value', displayExpr: 'text' }"
                            [headerFilter]="{ dataSource: payrollCompanyCodeOptions }"
                >
                </dxi-column>
            }
            @if (authService.checkPermission(PermissionType.EmployeeFinancialDetailsOthers, AccessType.ViewOnly)) {
                <dxi-column
                            [allowSearch]="false" [visible]="false" [dataField]="gridFieldName('regularPayRateCode')"
                            caption="Pay rate code" [hidingPriority]="9"
                            cellTemplate="cellDefault"
                            [minWidth]="150"
                            [lookup]="{ dataSource: regularPayRateCodeOptions, valueExpr: 'value', displayExpr: 'text' }"
                            [headerFilter]="{ dataSource: regularPayRateCodeOptions }"
                >
                </dxi-column>
            }
            @if (authService.checkPermission(PermissionType.EmployeeFinancialDetailsOthers, AccessType.ViewOnly)) {
                <dxi-column
                            [allowSearch]="false" [visible]="false" [dataField]="gridFieldName('payRateAmount')" caption="Pay rate amount"
                            [hidingPriority]="8"
                            cellTemplate="cellCurrency"
                            [minWidth]="150"></dxi-column>
            }
            @if (authService.checkPermission(PermissionType.EmployeeFinancialDetailsOthers, AccessType.ViewOnly)) {
                <dxi-column
                            [allowSearch]="false" [visible]="false" [dataField]="gridFieldName('annualSalary')" caption="Annual salary"
                            [hidingPriority]="7"
                            cellTemplate="cellCurrency"
                            [minWidth]="150"></dxi-column>
            }
            @if (authService.checkPermission(PermissionType.EmployeeEmploymentDetailsOthers, AccessType.ViewOnly)) {
                <dxi-column
                            [allowSearch]="false" [visible]="false" [dataField]="gridFieldName('birthDate')" caption="Birth date"
                            [hidingPriority]="6"
                            [minWidth]="150" dataType="date" selectedFilterOperation=">=" cellTemplate="cellDate"></dxi-column>
            }
            @if (authService.checkPermission(PermissionType.EmployeeFinancialDetailsOthers, AccessType.ViewOnly)) {
                <dxi-column
                            [allowSearch]="false" [visible]="false" [dataField]="gridFieldName('regularPayEffectiveDate')"
                            caption="Pay effective date"
                            [hidingPriority]="5" [minWidth]="150" dataType="date" selectedFilterOperation=">=" cellTemplate="cellDate"></dxi-column>
            }
            @if (authService.checkPermission(PermissionType.EmployeeEmploymentDetailsOthers, AccessType.ViewOnly)) {
                <dxi-column
                            [allowSearch]="false" [visible]="false" [dataField]="gridFieldName('hireDate')" caption="Hire date"
                            [hidingPriority]="4"
                            [minWidth]="150" dataType="date" selectedFilterOperation=">=" cellTemplate="cellDate"></dxi-column>
            }
            @if (authService.checkPermission(PermissionType.EmployeeEmploymentDetailsOthers, AccessType.ViewOnly)) {
                <dxi-column
                            [allowSearch]="false" [visible]="false" [dataField]="gridFieldName('paidPosition')" caption="Paid position"
                            [hidingPriority]="3"
                            cellTemplate="cellDefault"
                            [minWidth]="150"></dxi-column>
            }
            @if (authService.checkPermission(PermissionType.EmployeeEmploymentDetailsOthers, AccessType.ViewOnly)) {
                <dxi-column
                            [allowSearch]="false" [visible]="false" [dataField]="gridFieldName('standardHours')" caption="Standard hours"
                            [hidingPriority]="2"
                            cellTemplate="cellDefault"
                            [minWidth]="150"></dxi-column>
            }
            @if (authService.checkPermission(PermissionType.EmployeeEmploymentDetailsOthers, AccessType.ViewOnly)) {
                <dxi-column
                            [allowSearch]="false" [visible]="false" [dataField]="gridFieldName('age')" caption="Age"
                            cellTemplate="cellDefault"
                            [minWidth]="150"></dxi-column>
                <dxi-column
                            [allowSearch]="false" [visible]="false" [dataField]="gridFieldName('yearsWorked')" caption="Years Worked"
                            cellTemplate="cellDefault"
                            [minWidth]="150"></dxi-column>
                <dxi-column
                            [allowSearch]="false" [visible]="false" [dataField]="gridFieldName('jobTitleDescription')"
                            caption="Job Title Description"
                            cellTemplate="cellText"
                            [minWidth]="150"
                            [lookup]="{ dataSource: jobTitleOptions, valueExpr: 'value', displayExpr: 'text' }"
                            [headerFilter]="{ dataSource: jobTitleOptions }"
                ></dxi-column>
                <dxi-column
                            [allowSearch]="false" [visible]="false" [dataField]="gridFieldName('sapAccess')" caption="SAP Access"
                            cellTemplate="cellText"
                            [minWidth]="150"
                            [lookup]="{ dataSource: yesNoOptions, valueExpr: 'value', displayExpr: 'text' }"
                            [headerFilter]="{ dataSource: yesNoOptions }"
                ></dxi-column>
                <dxi-column
                            [allowSearch]="false" [visible]="false" [dataField]="gridFieldName('dwaAccess')" caption="DWA Access"
                            cellTemplate="cellText"
                            [minWidth]="150"
                            [lookup]="{ dataSource: yesNoOptions, valueExpr: 'value', displayExpr: 'text' }"
                            [headerFilter]="{ dataSource: yesNoOptions }"
                ></dxi-column>
                <dxi-column
                            [allowSearch]="false" [visible]="false" [dataField]="gridFieldName('nextViewAccess')" caption="NextView Access"
                            cellTemplate="cellText"
                            [minWidth]="150"
                            [lookup]="{ dataSource: yesNoOptions, valueExpr: 'value', displayExpr: 'text' }"
                            [headerFilter]="{ dataSource: yesNoOptions }"
                ></dxi-column>
            }
            @if (authService.checkPermission(PermissionType.EmployeeNestleDetailsOthers, AccessType.ViewOnly)) {
                <dxi-column
                            [allowSearch]="false" [visible]="false" [dataField]="gridFieldName('nestleStatus')" caption="Nestle Status"
                            cellTemplate="cellNestleStatus"
                            [minWidth]="150"
                            [filterOperations]="['=']"
                            [lookup]="{ dataSource: nestleStatusOptions, valueExpr: 'value', displayExpr: 'text' }"
                            [headerFilter]="{ dataSource: nestleStatusOptions }"
                ></dxi-column>
                <dxi-column
                            [allowSearch]="false" [visible]="false" [dataField]="gridFieldName('nestleDetailsAdpHireDate')"
                            caption="Nestle ADP Hire Date"
                            [minWidth]="150" dataType="date" selectedFilterOperation=">=" cellTemplate="cellDate"></dxi-column>
                <dxi-column
                            [allowSearch]="false" [visible]="false" [dataField]="gridFieldName('nestleDetailsNewHire')" caption="Nestle New Hire"
                            cellTemplate="cellText"
                            [minWidth]="150"
                            [lookup]="{ dataSource: yesNoOptions, valueExpr: 'value', displayExpr: 'text' }"
                            [headerFilter]="{ dataSource: yesNoOptions }"
                ></dxi-column>
                <dxi-column
                            [allowSearch]="false" [visible]="false" [dataField]="gridFieldName('nestleDetailsAgency')" caption="Nestle Agency"
                            cellTemplate="cellDefault"
                            [minWidth]="150"></dxi-column>
                <dxi-column
                            [allowSearch]="false" [visible]="false" [dataField]="gridFieldName('nestleDetailsPositionId')"
                            caption="Nestle Position ID"
                            cellTemplate="cellDefault"
                            [minWidth]="150"></dxi-column>
                <dxi-column
                            [allowSearch]="false" [visible]="false" [dataField]="gridFieldName('nestleDetailsSapSuccessFactorId')"
                            caption="Nestle SAP/Success Factor ID"
                            cellTemplate="cellDefault"
                            [minWidth]="150"></dxi-column>
                <dxi-column
                            [allowSearch]="false" [visible]="false" [dataField]="gridFieldName('nestleDetailsEmployeeId')"
                            caption="Nestle Employee ID"
                            cellTemplate="cellDefault"
                            [minWidth]="150"></dxi-column>
                <dxi-column
                            [allowSearch]="false" [visible]="false" [dataField]="gridFieldName('nestleDetailsNestleUserId')"
                            caption="Nestle User ID"
                            cellTemplate="cellDefault"
                            [minWidth]="150"></dxi-column>
                <dxi-column
                            [allowSearch]="false" [visible]="false" [dataField]="gridFieldName('nestleDetailsEmail')" caption="Nestle Email"
                            cellTemplate="cellDefault"
                            [minWidth]="150"></dxi-column>
                <dxi-column
                            [allowSearch]="false" [visible]="false" [dataField]="gridFieldName('nestleDetailsNextPasswordExpiryDate')"
                            caption="Nestle Next Password Expiry Date"
                            [minWidth]="150" dataType="date" selectedFilterOperation=">=" cellTemplate="cellDate"></dxi-column>
            }

            <div *dxTemplate="let cellInfo of 'name'" class="name-template">
                <user-avatar-email
                    [email]="getCellData(cellInfo).email"
                    [name]="getCellData(cellInfo).name"
                    [avatarUrl]="getCellData(cellInfo).avatarUrl"
                ></user-avatar-email>
            </div>

            <div *dxTemplate="let cellInfo of 'cellStatus'">
                <contact-status [value]="getCellData(cellInfo).positionStatus"
                                [text]="getCellData(cellInfo).positionStatus | positionStatus"></contact-status>
            </div>

            <div *dxTemplate="let cellInfo of 'cellClockInStatus'">
                <contact-status [value]="getClockInStatus(cellInfo) | dasherize"
                                [text]="getCellData(cellInfo).punchInStatus | capitalCase"></contact-status>
            </div>

            <div *dxTemplate="let cellInfo of 'cellClockOutStatus'">
                <contact-status [value]="getClockOutStatus(cellInfo) | dasherize"
                                [text]="getCellData(cellInfo).punchOutStatus | capitalCase"></contact-status>
            </div>

            <div *dxTemplate="let cellInfo of 'cellRequests'">
                @if (getCellData(cellInfo).requests > 0) {
                    <span class="badge-danger-round">{{ getCellData(cellInfo).requests }}</span>
                }
            </div>

            <div *dxTemplate="let cellInfo of 'cellDefault'">
                @if (cellInfo.value === null || cellInfo.value === '') {
                    <span class="text-secondary fst-italic">Missing</span>
                } @else {
                    {{ cellInfo.value }}
                }
            </div>

            <div *dxTemplate="let cellInfo of 'cellUpper'">
                @if (cellInfo.value === null || cellInfo.value === '') {
                    <span class="text-secondary fst-italic">Missing</span>
                } @else {
                    {{ cellInfo.value | uppercase }}
                }
            </div>

            <div *dxTemplate="let cellInfo of 'cellCapitalUpper'">
                @if (cellInfo.value === null || cellInfo.value === '') {
                    <span class="text-secondary fst-italic">Missing</span>
                } @else {
                    {{ cellInfo.value | capitalCase | uppercase }}
                }
            </div>

            <div *dxTemplate="let cellInfo of 'cellDate'">
                @if (!cellInfo.value) {
                    <span class="text-secondary fst-italic">Missing</span>
                } @else {
                    {{ cellInfo.value | date:'longDate' }}
                }
            </div>

            <div *dxTemplate="let cellInfo of 'cellText'">
                @if (cellInfo.value === null || cellInfo.value === '') {
                    <span class="text-secondary fst-italic">Missing</span>
                } @else {
                    {{ cellInfo.text }}
                }
            </div>

            <div *dxTemplate="let cellInfo of 'cellNestleStatus'">
                @if (getCellData(cellInfo).nestleStatus) {
                    <span class="badge" [ngClass]="getNestleStatusBadgeClass(getCellData(cellInfo).nestleStatus)">
                        {{ getCellData(cellInfo).nestleStatus | nestleStatus }}
                    </span>
                }
            </div>

            <div *dxTemplate="let cellInfo of 'cellCurrency'">
                @if (cellInfo.value === null || cellInfo.value === '') {
                    <span class="text-secondary fst-italic">Missing</span>
                } @else {
                    {{ cellInfo.value | currency }}
                }
            </div>
        </dx-data-grid>
    </div>
    <filter-panel
        [(isOpened)]="isFilterPanelOpened"
        (onSearch)="applyFilters()"
        (onClear)="clearFilters()"
        (pinnedChange)="onPinnedChange()"
    >
        <dx-form [formData]="filterModel">
            <dxi-item
                [dataField]="filterModelName('name')"
                editorType="dxTextBox"
                [editorOptions]="{ placeholder: 'Name', stylingMode: 'filled' }"
                [colSpan]="1"
            ></dxi-item>
            @if (authService.checkPermission(PermissionType.EmployeeEmploymentDetailsOthers, AccessType.ViewOnly)) {
                <dxi-item
                    [dataField]="filterModelName('positionStatus')"
                    editorType="dxSelectBox"
                    [editorOptions]="{ items: statusOptions, valueExpr: 'value', displayExpr: 'text', placeholder: 'Status', stylingMode: 'filled' }"
                    [colSpan]="1"
                ></dxi-item>
            }
            @if (authService.checkPermission(PermissionType.EmployeeShiftDetailsOthers, AccessType.ViewOnly)) {
                <dxi-item
                    [dataField]="filterModelName('shiftType')"
                    editorType="dxSelectBox"
                    [editorOptions]="{ items: shiftTypeOptions, valueExpr: 'value', displayExpr: 'text', placeholder: 'Shift Type', stylingMode: 'filled' }"
                    [colSpan]="1"
                ></dxi-item>
            }

            <dxi-item
                [dataField]="filterModelName('punchInStatus')"
                editorType="dxSelectBox"
                [editorOptions]="{ items: clockInStatusOptions, valueExpr: 'value', displayExpr: 'text', placeholder: 'Clock In Status', stylingMode: 'filled' }"
                [colSpan]="1"
            ></dxi-item>
            <dxi-item
                [dataField]="filterModelName('punchOutStatus')"
                editorType="dxSelectBox"
                [editorOptions]="{ items: clockOutStatusOptions, valueExpr: 'value', displayExpr: 'text', placeholder: 'Clock Out Status', stylingMode: 'filled' }"
                [colSpan]="1"
            ></dxi-item>
            <dxi-item
                [dataField]="filterModelName('lastUpdated')"
                editorType="dxDateBox"
                [editorOptions]="{ placeholder: 'Last Updated', stylingMode: 'filled', displayFormat: 'shortDate' }"
                [colSpan]="1"
            ></dxi-item>

            @if (authService.checkPermission(PermissionType.EmployeeEmploymentDetailsOthers, AccessType.ViewOnly)) {
                <dxi-item
                    [dataField]="filterModelName('positionId')"
                    editorType="dxTextBox"
                    [editorOptions]="{ placeholder: 'Position Id', stylingMode: 'filled' }"
                    [colSpan]="1"
                ></dxi-item>
                <dxi-item
                    [dataField]="filterModelName('homeCostNumberCode')"
                    editorType="dxTextBox"
                    [editorOptions]="{ placeholder: 'Home cost number code', stylingMode: 'filled' }"
                    [colSpan]="1"
                ></dxi-item>
                <dxi-item
                    [dataField]="filterModelName('homeDepartmentCode')"
                    editorType="dxTextBox"
                    [editorOptions]="{ placeholder: 'Home Department Code', stylingMode: 'filled' }"
                    [colSpan]="1"
                ></dxi-item>
                <dxi-item
                    [dataField]="filterModelName('payClass')"
                    editorType="dxSelectBox"
                    [editorOptions]="{ placeholder: 'Pay class', stylingMode: 'filled' }"
                    [colSpan]="1"
                ></dxi-item>
                <dxi-item
                    [dataField]="filterModelName('taxId')"
                    editorType="dxTextBox"
                    [editorOptions]="{ placeholder: 'Tax Id', stylingMode: 'filled' }"
                    [colSpan]="1"
                ></dxi-item>
                <dxi-item
                    [dataField]="filterModelName('payrollCompanyCode')"
                    editorType="dxSelectBox"
                    [editorOptions]="{ items: payrollCompanyCodeOptions, valueExpr: 'value', displayExpr: 'text', placeholder: 'Payroll company code', stylingMode: 'filled' }"
                    [colSpan]="1"
                ></dxi-item>
                <dxi-item
                    [dataField]="filterModelName('birthDate')"
                    editorType="dxDateBox"
                    [editorOptions]="{ placeholder: 'Birth date', stylingMode: 'filled', displayFormat: 'shortDate' }"
                    [colSpan]="1"
                ></dxi-item>
                <dxi-item
                    [dataField]="filterModelName('hireDate')"
                    editorType="dxDateBox"
                    [editorOptions]="{ placeholder: 'Hire date', stylingMode: 'filled', displayFormat: 'shortDate' }"
                    [colSpan]="1"
                ></dxi-item>
                <dxi-item
                    [dataField]="filterModelName('paidPosition')"
                    editorType="dxTextBox"
                    [editorOptions]="{ placeholder: 'Paid position', stylingMode: 'filled' }"
                    [colSpan]="1"
                ></dxi-item>
                <dxi-item
                    [dataField]="filterModelName('standardHours')"
                    editorType="dxNumberBox"
                    [editorOptions]="{ placeholder: 'Standard hours', stylingMode: 'filled' }"
                    [colSpan]="1"
                ></dxi-item>
            }

            @if (authService.checkPermission(PermissionType.UserEmergencyDetailsOthers, AccessType.ViewOnly)) {
                <dxi-item
                    [dataField]="filterModelName('emergencyContactName')"
                    editorType="dxTextBox"
                    [editorOptions]="{ placeholder: 'Emergency contact name', stylingMode: 'filled' }"
                    [colSpan]="1"
                ></dxi-item>
                <dxi-item
                    [dataField]="filterModelName('emergencyContactNumber')"
                    editorType="dxTextBox"
                    [editorOptions]="{ placeholder: 'Emergency contact number', stylingMode: 'filled' }"
                    [colSpan]="1"
                ></dxi-item>
                <dxi-item
                    [dataField]="filterModelName('medicalConditions')"
                    editorType="dxTextBox"
                    [editorOptions]="{ placeholder: 'Medical conditions', stylingMode: 'filled' }"
                    [colSpan]="1"
                ></dxi-item>
            }

            @if (authService.checkPermission(PermissionType.EmployeeFinancialDetailsOthers, AccessType.ViewOnly)) {
                <dxi-item
                    [dataField]="filterModelName('regularPayRateCode')"
                    editorType="dxSelectBox"
                    [editorOptions]="{ items: regularPayRateCodeOptions, valueExpr: 'value', displayExpr: 'text', placeholder: 'Pay rate code', stylingMode: 'filled' }"
                    [colSpan]="1"
                ></dxi-item>
                <dxi-item
                    [dataField]="filterModelName('payRateAmount')"
                    editorType="dxNumberBox"
                    [editorOptions]="{ placeholder: 'Pay rate amount', stylingMode: 'filled' }"
                    [colSpan]="1"
                ></dxi-item>
                <dxi-item
                    [dataField]="filterModelName('annualSalary')"
                    editorType="dxNumberBox"
                    [editorOptions]="{ placeholder: 'Annual salary', stylingMode: 'filled' }"
                    [colSpan]="1"
                ></dxi-item>
                <dxi-item
                    [dataField]="filterModelName('regularPayEffectiveDate')"
                    editorType="dxDateBox"
                    [editorOptions]="{ placeholder: 'Pay effective date', stylingMode: 'filled', displayFormat: 'shortDate' }"
                    [colSpan]="1"
                ></dxi-item>
            }
        </dx-form>
    </filter-panel>
    <form-popup [(visible)]="isAddEmployeePopupOpened" (save)="onAddEmployeePopupSaveClick()" titleText="New Employee">
        <add-employee-form [employeeRolesOnly]="true" [showCarrierFields]="false" [showSupplierFields]="false"></add-employee-form>
    </form-popup>
</div>
